import SocialVortex from './vortex.js';
import Map3D from './map3d.js';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let themeToggle, body, heroTitle, heroSubtitle, videoSource, heroVideo, suggestionBox, suggestionText, exploreBtn, soundToggle;
let vortex, map3d;
let isMuted = true;

// Sound Data
const audioSpring = new Audio('https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3'); 
const audioEurovision = new Audio('https://www.soundhelix.com/examples/mp3/SoundHelix-Song-8.mp3'); 
audioSpring.loop = true;
audioEurovision.loop = true;

// Theme Data
const themes = {
    spring: {
        title: "Spring of Life",
        subtitle: "Discover the blooming nature and crisp lakes of Finland.",
        buttonText: "Switch to Eurovision",
        video: "https://cdn.pixabay.com/vimeo/328135061/forest-22684.mp4?width=1280&hash=8b5b5b5b5b5b5b5b5b5b5b5b5b5b5b5b5b5b5b5b"
    },
    eurovision: {
        title: "Eurovision Fever",
        subtitle: "Join the neon-lit party and feel the rhythm of the north.",
        buttonText: "Back to Nature",
        video: "https://cdn.pixabay.com/vimeo/328135061/forest-22684.mp4?width=1280&hash=8b5b5b5b5b5b5b5b5b5b5b5b5b5b5b5b5b5b5b5b"
    }
};

const moodData = {
    nature: { text: "Follow the call of the wild...", video: "https://cdn.pixabay.com/vimeo/328135061/forest-22684.mp4?width=1280", target: "#nature" },
    party: { text: "The night is young...", video: "https://cdn.pixabay.com/vimeo/328135061/forest-22684.mp4?width=1280", target: "#culture" },
    innovation: { text: "Designing the future...", video: "https://cdn.pixabay.com/vimeo/328135061/forest-22684.mp4?width=1280", target: "#vortex-section" }
};

function updateAudio(theme) {
    if (isMuted) {
        audioSpring.pause();
        audioEurovision.pause();
        return;
    }
    if (theme === 'spring') {
        audioEurovision.pause();
        audioSpring.play().catch(e => console.log("Audio play blocked"));
    } else {
        audioSpring.pause();
        audioEurovision.play().catch(e => console.log("Audio play blocked"));
    }
}

function updateThemeContent(theme) {
    const data = themes[theme];
    heroTitle.style.opacity = 0;
    heroSubtitle.style.opacity = 0;
    setTimeout(() => {
        heroTitle.textContent = data.title;
        heroSubtitle.textContent = data.subtitle;
        themeToggle.textContent = data.buttonText;
        videoSource.src = data.video;
        heroVideo.load();
        heroVideo.play();
        heroTitle.style.opacity = 1;
        heroSubtitle.style.opacity = 1;
        suggestionBox.style.display = 'none';
        if (vortex) vortex.updateTheme(theme);
        if (map3d) map3d.updateTheme(theme);
    }, 500);
}

document.addEventListener('DOMContentLoaded', () => {
    themeToggle = document.getElementById('themeToggle');
    body = document.body;
    heroTitle = document.getElementById('heroTitle');
    heroSubtitle = document.getElementById('heroSubtitle');
    videoSource = document.getElementById('videoSource');
    heroVideo = document.getElementById('heroVideo');
    suggestionBox = document.getElementById('suggestionBox');
    suggestionText = document.getElementById('suggestionText');
    exploreBtn = document.getElementById('exploreBtn');
    soundToggle = document.getElementById('soundToggle');

    heroTitle.style.transition = 'opacity 0.5s ease';
    heroSubtitle.style.transition = 'opacity 0.5s ease';

    themeToggle.addEventListener('click', () => {
        const currentTheme = body.getAttribute('data-theme');
        const newTheme = currentTheme === 'spring' ? 'eurovision' : 'spring';
        body.setAttribute('data-theme', newTheme);
        updateThemeContent(newTheme);
        updateAudio(newTheme);
    });

    soundToggle.addEventListener('click', () => {
        isMuted = !isMuted;
        soundToggle.textContent = isMuted ? '🔇' : '🔊';
        updateAudio(body.getAttribute('data-theme'));
    });

    document.querySelectorAll('.mood-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const mood = btn.getAttribute('data-mood');
            const data = moodData[mood];
            suggestionText.textContent = data.text;
            suggestionBox.style.display = 'block';
            videoSource.src = data.video;
            heroVideo.load();
            heroVideo.play();
            exploreBtn.onclick = () => {
                document.querySelector(data.target).scrollIntoView({ behavior: 'smooth' });
            };
        });
    });

    const cursor = document.getElementById('custom-cursor');
    document.addEventListener('mousemove', (e) => {
        cursor.style.left = e.clientX + 'px';
        cursor.style.top = e.clientY + 'px';
    });

    const interactiveElements = 'button, a, .mood-btn, .category-btn, .quiz-option, .culture-card';
    document.querySelectorAll(interactiveElements).forEach(el => {
        el.addEventListener('mouseenter', () => cursor.classList.add('hover'));
        el.addEventListener('mouseleave', () => cursor.classList.remove('hover'));
    });

    try {
        vortex = new SocialVortex('vortex-container');
        vortex.updateTheme(body.getAttribute('data-theme'));
    } catch (e) { console.error("Vortex Error:", e); }

    try {
        map3d = new Map3D('map-3d-container');
        map3d.updateTheme(body.getAttribute('data-theme'));
    } catch (e) { console.error("Map3D Error:", e); }

    updateAudio(body.getAttribute('data-theme'));

    const cultureBg = document.getElementById('cultureBg');
    const cultureCards = document.querySelectorAll('.culture-card');
    cultureCards.forEach(card => {
        card.addEventListener('mouseenter', () => {
            const newImage = card.getAttribute('data-image');
            cultureBg.style.opacity = 0;
            cultureBg.style.transform = 'scale(1.1)';
            setTimeout(() => {
                cultureBg.src = newImage;
                cultureBg.style.opacity = 1;
                cultureBg.style.transform = 'scale(1)';
            }, 400);
        });
    });

    gsap.to('.hero-content', {
        scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true },
        y: 200, opacity: 0
    });

    const seasonData = {
        0: { name: "Spring", temp: "+5°C", daylight: "14h", desc: "Watch the world wake up after the long winter.", img: "https://images.unsplash.com/photo-1516738901171-8eb4fc13bd20?auto=format&fit=crop&q=80&w=800" },
        1: { name: "Summer", temp: "+22°C", daylight: "24h", desc: "Experience the magic of the midnight sun.", img: "https://images.unsplash.com/photo-1543349689-9a4d426bee87?auto=format&fit=crop&q=80&w=800" },
        2: { name: "Autumn", temp: "+8°C", daylight: "12h", desc: "The 'Ruska' brings fiery colors to the forests.", img: "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?auto=format&fit=crop&q=80&w=800" },
        3: { name: "Winter", temp: "-15°C", daylight: "4h", desc: "A silent wonderland under the northern lights.", img: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&q=80&w=800" }
    };

    const range = document.getElementById('seasonRange');
    if (range) {
        range.addEventListener('input', (e) => {
            const val = e.target.value;
            const data = seasonData[val];
            document.getElementById('seasonName').textContent = data.name;
            document.getElementById('statTemp').textContent = data.temp;
            document.getElementById('statDaylight').textContent = data.daylight;
            document.getElementById('seasonDesc').textContent = data.desc;
            const img = document.getElementById('seasonImage');
            img.style.opacity = 0;
            setTimeout(() => { img.src = data.img; img.style.opacity = 1; }, 300);
        });
    }

    const startQuizBtn = document.getElementById('startQuizBtn');
    const quizStart = document.getElementById('quiz-start');
    const quizQuestionsDiv = document.getElementById('quiz-questions');
    const quizResult = document.getElementById('quiz-result');
    const quizBar = document.getElementById('quizBar');
    const questionText = document.getElementById('questionText');
    const quizOptions = document.getElementById('quizOptions');

    const quizQuestions = [
        { q: "Where do you find your peace?", a: [{ t: "A steamy wooden cabin", v: "sauna" }, { t: "Under the neon lights", v: "karaoke" }, { t: "Deep in the green forest", v: "nature" }] },
        { q: "What's your favorite sound?", a: [{ t: "Crackling wood fire", v: "sauna" }, { t: "A cheering crowd", v: "karaoke" }, { t: "The silence of the lakes", v: "nature" }] },
        { q: "Pick a visual vibe:", a: [{ t: "Soft candlelight", v: "sauna" }, { t: "Strobe lights & glitter", v: "karaoke" }, { t: "The golden hour sun", v: "nature" }] }
    ];

    let currentQuestion = 0;
    let scores = { sauna: 0, karaoke: 0, nature: 0, culture: 0 };

    if (startQuizBtn) {
        startQuizBtn.addEventListener('click', () => {
            quizStart.style.display = 'none';
            quizQuestionsDiv.style.display = 'block';
            showQuestion();
        });
    }

    function showQuestion() {
        const q = quizQuestions[currentQuestion];
        questionText.textContent = q.q;
        quizBar.style.width = `${(currentQuestion / quizQuestions.length) * 100}%`;
        quizOptions.innerHTML = '';
        q.a.forEach(opt => {
            const btn = document.createElement('button');
            btn.className = 'quiz-option';
            btn.textContent = opt.t;
            btn.onclick = () => {
                scores[opt.v]++;
                currentQuestion++;
                if (currentQuestion < quizQuestions.length) showQuestion();
                else showResult();
            };
            quizOptions.appendChild(btn);
        });
    }

    function showResult() {
        quizQuestionsDiv.style.display = 'none';
        quizResult.style.display = 'block';
        quizBar.style.width = '100%';
        const winner = Object.keys(scores).reduce((a, b) => scores[a] > scores[b] ? a : b);
        const results = {
            sauna: { title: "The Sauna Stoic", desc: "You find happiness in the steam and the silence." },
            karaoke: { title: "The Midnight Star", desc: "You celebrate life through song and social connection." },
            nature: { title: "The Forest Wanderer", desc: "The lakes and woods are your sanctuary." },
            culture: { title: "The Design Dreamer", desc: "You appreciate the functional beauty and innovation." }
        };
        document.getElementById('resultTitle').textContent = results[winner].title;
        document.getElementById('resultDesc').textContent = results[winner].desc;
        document.getElementById('seeOnMapBtn').onclick = () => {
            document.getElementById('map-section').scrollIntoView({ behavior: 'smooth' });
            const category = winner === 'nature' || winner === 'culture' ? 'people' : winner;
            const btn = document.querySelector(`.category-btn[data-category="${category}"]`);
            if (btn) btn.click();
        };
    }
});
